import { useState, useRef } from 'react';
import { Box } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { useForm } from 'react-hook-form';
import UserSearchBack from '@/assets/img/user-search-back.png';
import UserSearchIcon from '@/assets/img/user-search-icon.png';
import UserSearchItemImg from '@/assets/img/user-search-item-img.png';
import UserSearchItemReset from '@/assets/img/user-search-item-reset.png';
import UserSearchItemFail from '@/assets/img/user-search-item-fail.png';
import UserIcon from '@/assets/img/user-icon.png';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import request from '@/utils/request';
import { TextFieldCom } from '@/components/FormType';
import UserQueryStyles from './userQueryStyled';

export default () => {
  const { handleSubmit, control, errors, setValue, getValues } = useForm();
  const searchRef = useRef();
  const sureRef = useRef();
  const [searchVal, setSearchVal] = useState('');
  const [userData, setUserData] = useState(null);
  const [emailOpen, setEmailOpen] = useState(false);
  const [hasValue, setHasValue] = useState(false);
  // 查询事件处理
  const handleSearchClick = async () => {
    window.NE_DAWN.trigger(searchRef.current, {
      event: '_ec', // 事件名
      params: { userName: searchVal }, // 事件公参
    });
    if (!searchVal) {
      setHasValue(false);
      setUserData(null);
      return;
    }
    const info = await request('/user/queryUserInfo', {
      method: 'POST',
      data: {
        userName: searchVal,
      },
    });
    if (info.code === 0) {
      setHasValue(true);
      setUserData(info.data);
    }
  };

  // 重置事件处理
  const handleRestClick = () => {
    setSearchVal('');
    setUserData(null);
    setHasValue(false);
  };

  const onFormSubmitFail = () => {
    console.log('fail');
  };
  //编辑content
  const resetEmailContent = () => {
    return (
      <form onSubmit={handleSubmit(onFormSubmitSuccess, onFormSubmitFail)}>
        <Box
          sx={{ width: '296px' }}
          data-log={JSON.stringify({
            oid: 'modal_page_sys_mgm_user_mgm_reset_pwd',
            isPage: true,
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            events: ['_pv', '_pd'],
          })}
        >
          <Box sx={{ marginTop: '10px' }}>
            <div
              style={{ fontSize: '12px', lineHeight: '17px', letterSpacing: 0 }}
            >
              账号
            </div>
            <div
              style={{
                marginTop: '6px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '25px',
                letterSpacing: 0,
              }}
            >
              {userData?.username}
            </div>
          </Box>
          <Box sx={{ marginTop: '10px' }}>
            <TextFieldCom
              initLabel={false} //自定义的label是否显示
              showLabel={true} //是否需要显示label
              placeholder="请输入"
              helperText="" //用于校验的提醒文字
              name="emailValue"
              label="用户邮箱" //label
              control={control}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              showError={true} //false输入框捕获到错误不展示错误样式，默认true
              isValidate="请输入正确的邮箱格式"
              rules={{
                required: true, //是否是必填项true 必填 false 非必填
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              }}
            />
          </Box>
          <Box
            sx={{
              marginTop: '30px',
              padding: '16px 28px',
              background: 'rgba(255,182,129, 0.2)',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '22px',
              letterSpacing: 0,
              textAlign: 'center',
              color: '#E96200',
            }}
          >
            重置后的新密码将发送到用户邮箱
            <br />
            请提醒用户及时查收并修改密码
          </Box>
        </Box>
        {initButton().buttonNode}
      </form>
    );
  };

  const onCloseEditDialog = () => {
    setEmailOpen(false);
    setValue('emailValue', '');
  };

  const onFormSubmitSuccess = async (data) => {
    window.NE_DAWN.trigger(sureRef.current, {
      event: '_ec', // 事件名
      params: {
        userId: userData.userId,
        userName: userData.username,
        email: data.emailValue,
      }, // 事件公参
    });
    try {
      const res = await request('/user/resetPwd', {
        method: 'POST',
        data: {
          userId: userData.userId,
          userName: userData.username,
          email: data.emailValue,
        },
      });
      if (res.code === 0) {
        setEmailOpen(false);
        setValue('emailValue', '');
        return window.message.toast({
          type: 'success',
          message: '重置成功',
          title: '成功',
        });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  //自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '0 24px',
          width: '100%',
          padding: '0 16px',
          marginTop: '20px',
          marginBottom: '12px',
        }}
      >
        <Button
          sx={{
            flex: 1,
          }}
          variant="contained"
          onClick={onCloseEditDialog}
          color="secondary"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
        >
          取消
        </Button>
        <Button
          sx={{ flex: 1 }}
          variant="contained"
          ref={sureRef}
          data-log={JSON.stringify({
            oid: 'btn_page_sys_mgm_user_mgm_reset_pwd_confirm',
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            mountParentSelector: '#user-search-box',
          })}
          type="submit"
          startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
        >
          确认重置
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const handleOpen = () => {
    const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setEmailOpen(true);
    if (regExp.test(userData.username)) {
      setTimeout(() => setValue('emailValue', userData.username));
    }
  };

  return (
    <UserQueryStyles>
      <div
        className="user-search-box"
        id="user-search-box"
        data-log={JSON.stringify({
          oid: 'page_sys_mgm_user_mgm',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <img
          className="user-search-back"
          src={UserSearchBack}
          alt=""
          srcset=""
        />
        <div className="user-search-wrap">
          <img
            className="user-search-icon"
            src={UserSearchIcon}
            alt=""
            srcset=""
          />
          <TextField
            className="user-search-text"
            name="memberCode"
            variant="standard"
            label="用户名"
            fullWidth
            value={searchVal}
            onChange={(e) => {
              setSearchVal(e.target.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                handleSearchClick();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className="clear-btn"
                    onClick={() => {
                      setSearchVal('');
                    }}
                    edge="end"
                  >
                    {searchVal ? <ClearIcon className="clear-icon" /> : ''}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              ref={searchRef}
              data-log={JSON.stringify({
                oid: 'btn_page_sys_mgm_user_mgm_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              onClick={() => {
                handleSearchClick();
              }}
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </div>
        </div>
      </div>
      {userData ? (
        <div className="user-search-content">
          <div className="user-search-item">
            <img
              className="user-search-item-img"
              src={UserSearchItemImg}
              alt=""
              srcset=""
            />
            <div className="user-search-item-right">
              <div className="user-search-item-right-info">
                <div className="user-name">
                  <img className="user-icon" src={UserIcon} alt="" srcset="" />
                  <span className="user-name-info">ECCO用户</span>
                </div>
                <div className="user-email">
                  <div className="user-email-label">用户名</div>
                  <div className="user-email-value">{userData.username}</div>
                </div>
              </div>
              <div
                className="user-search-item-right-reset-wrap"
                onClick={handleOpen}
              >
                <img
                  className="user-search-item-right-reset-icon"
                  src={UserSearchItemReset}
                  alt=""
                  srcset=""
                />
                <span>重置</span>
              </div>
            </div>
          </div>
        </div>
      ) : hasValue ? (
        <div className="user-search-no-data">
          <img
            className="user-search-back"
            src={UserSearchItemFail}
            alt=""
            srcset=""
          />
          <div className="word-h1">没有找到</div>
          <div className="word-h2">
            请检查是否存在拼写错误
            <br />
            重新再试
          </div>
        </div>
      ) : (
        ''
      )}
      <DialogDataML
        open={emailOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#212121',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                style={{ width: '24px', marginRight: '8px' }}
                src={UserSearchItemReset}
                alt=""
                srcset=""
              />
              重置密码
            </span>
            <CloseIcon
              onClick={onCloseEditDialog}
              sx={{ width: '24px', height: '24px' }}
            />
          </Box>
        }
        content={resetEmailContent()}
        handleClose={onCloseEditDialog}
        button={{ isShow: false }}
      />
    </UserQueryStyles>
  );
};
